<template>
  <v-card class="mb-3" style="border-radius: 10px;">
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 sm7 pa-0>
          <h1 class="headline font-weight-thin">{{record.title}}</h1>
        </v-flex>
        <v-flex xs12 sm5 pa-0 text-xs-left text-sm-right px-1>
        </v-flex>

        <v-flex xs12 py-0>
          <v-container py-3 px-0>
            <v-layout row wrap>
              <v-flex xs12>
                <v-layout row wrap body-1>
                  <v-flex xs6 sm2 py-0 order-xs1 order-sm1>
                    {{humanWireDate}}
                  </v-flex>
                  <v-flex xs12 sm8 py-0 order-xs5 order-sm2>
                    <div class="hidden-xs-only">
                      {{l(value, record.currency)}} convertidos para {{l(exchanged_value, record.exchange_currency)}} ({{record.exchange_rate}})
                    </div>
                    <div class="hidden-sm-and-up">
                      {{l(value, record.currency)}}
                    </div>
                    <div class="hidden-sm-and-up">
                      convertidos para {{l(exchanged_value, record.exchange_currency)}} ({{record.exchange_rate}})
                    </div>
                  </v-flex>
                  <v-flex xs6 sm2 py-0 text-sm-right order-xs3 order-sm3>
                    Transações: {{record.transactions.length}}
                  </v-flex>
                  <v-flex xs6 sm2 py-0 order-xs2 text-sm-left text-xs-right order-sm4>
                    {{humanWireTime}}
                  </v-flex>
                  <v-flex xs12 sm8 py-0 order-xs6 order-sm5>
                    IOF {{record.iof_rate * 100.0}}% ({{l(iof_value, currency)}})
                    FX {{record.fx_rate * 100.0}}% ({{l(fx_value, currency)}})
                  </v-flex>
                  <v-flex xs6 sm2 py-0 text-xs-right order-xs4 order-sm6>
                    {{record.currency}} => {{record.exchange_currency}}
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>

      </v-layout>
    </v-container>
    <v-card-actions>
      <v-layout column>
        <v-flex xs12>
          <v-btn v-if="showMoreBtn" block dark class="ma-0 btn-style" >
            EXIBIR MAIS
          </v-btn>
          <slot></slot>
        </v-flex>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>

<script>
import TransactionItem from "./ExchangeTransactionItem"
import utils from "./shared/Utils"

export default {
  name: 'AdminWireConfirmation',
  components: { 'transaction': TransactionItem },
  props: {
    record: {
      type: Object
    }
  },
  data() {
    return {
      showMoreBtn: false,
      value: 0,
      fx_value: 0,
      iof_value: 0,
      currency: '',
      exchanged_value: 0
    }
  },
  mounted() {
    this.value = this.record.transactions.reduce( ( acc, record ) => acc + Number(record.exchanged_value), 0 ).toFixed(2)
    this.currency = this.record.transactions[0] && this.record.transactions[0].currency
    this.fx_value = (this.value * Number(this.record.fx_rate)).toFixed(2)
    this.iof_value = ((this.value - this.fx_value) * Number(this.record.iof_rate)).toFixed(2)
    this.exchanged_value = ((this.value - this.fx_value - this.iof_value) * this.record.exchange_rate).toFixed(2)
  },
  methods: {
    l(number_value, currency) {
      return utils.currencyToLocal(number_value, currency)
    }
  },
  computed: {
    humanWireDate() {
      return utils.dbDateTimeToHuman(new Date()).split(' ')[0]
    },
    humanWireTime() {
      return utils.dbDateTimeToHuman(new Date()).split(' ')[1]
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/AdminWireConfirmation.vue